import { Capacitor, SystemBarType, SystemBars, SystemBarsStyle } from "@capacitor/core";

const HARMONY_SYNC_RETRY_DELAYS = [80, 300, 1000];

function getHarmonySystemBarsBridge() {
    if (typeof window === "undefined") {
        return null;
    }

    const bridge = window.DB_HARMONY_HTTP;
    return bridge && typeof bridge.syncSystemBarsTheme === "function" ? bridge : null;
}

function syncHarmonySystemBarsTheme(isDark) {
    if (typeof window === "undefined") {
        return;
    }

    const theme = isDark ? "dark" : "light";
    const sync = () => {
        const bridge = getHarmonySystemBarsBridge();
        if (!bridge) return false;

        try {
            Promise.resolve(bridge.syncSystemBarsTheme(theme)).catch(() => {});
        } catch {
            return false;
        }

        return true;
    };

    if (sync()) {
        return;
    }

    HARMONY_SYNC_RETRY_DELAYS.forEach((delay) => {
        window.setTimeout(sync, delay);
    });
}

export function syncAndroidStatusBarTheme(isDark) {
    if (!Capacitor?.isNativePlatform?.() || Capacitor.getPlatform?.() !== "android") {
        return;
    }

    const style = isDark ? SystemBarsStyle.Dark : SystemBarsStyle.Light;

    Promise.allSettled([
        SystemBars.setStyle({
            bar: SystemBarType.StatusBar,
            style,
        }),
        SystemBars.setStyle({
            bar: SystemBarType.NavigationBar,
            style,
        }),
    ]);
}

export function syncNativeSystemBarsTheme(isDark) {
    syncAndroidStatusBarTheme(isDark);
    syncHarmonySystemBarsTheme(isDark);
}
